import { createSelector } from 'reselect';

const configSelector = (state) => state.api.config;

export const getTripConsequenceKeys = createSelector(configSelector, (config) => {
  const tripConsequences = config.tripConsequence || [];
  return new Set(tripConsequences.map((tc) => tc.consequence));
});

export const getTripConsequenceComments = createSelector(configSelector, (config) => {
  const tripConsequences = config.tripConsequence || [];
  const map = {};
  tripConsequences.forEach((tc) => {
    map[tc.consequence] = tc.comment;
  });
  return map;
});
